const VERBS = [
  "Swift",
  "Bold",
  "Quiet",
  "Fierce",
  "Wandering",
  "Rising",
  "Hidden",
  "Burning",
  "Frozen",
  "Shattered",
  "Glimmering",
  "Roaring",
  "Silent",
  "Daring",
  "Ancient",
  "Radiant",
  "Cunning",
  "Valiant",
  "Restless",
  "Storming",
  "Drifting",
  "Surging",
  "Echoing",
  "Forging",
  "Hunting",
  "Guarding",
  "Seeking",
  "Binding",
  "Breaking",
  "Calling",
  "Howling",
  "Soaring",
  "Veiled",
  "Crimson",
  "Gilded",
  "Hollow",
  "Iron",
  "Jade",
  "Keen",
  "Luminous",
  "Mighty",
  "Noble",
  "Obsidian",
  "Primal",
  "Raging",
  "Scarlet",
  "Thunder",
  "Untamed",
  "Vigilant",
  "Wild",
  "Zealous",
  "Arcane",
  "Blessed",
  "Cursed",
  "Dusk",
  "Eternal",
  "Fabled",
  "Grim",
  "Hallowed",
  "Ivory",
];

const NOUNS = [
  "Oak",
  "River",
  "Blade",
  "Ember",
  "Storm",
  "Wolf",
  "Crow",
  "Shard",
  "Tide",
  "Crown",
  "Ash",
  "Sparrow",
  "Hammer",
  "Lantern",
  "Thorn",
  "Harbor",
  "Falcon",
  "Mirror",
  "Anvil",
  "Glyph",
  "Raven",
  "Citadel",
  "Oracle",
  "Wyrm",
  "Sable",
  "Quarry",
  "Nexus",
  "Vanguard",
  "Relic",
  "Horizon",
  "Aegis",
  "Beacon",
  "Canyon",
  "Dagger",
  "Eclipse",
  "Fang",
  "Grove",
  "Hawk",
  "Ivory",
  "Jade",
  "Knight",
  "Lotus",
  "Mosaic",
  "Night",
  "Oath",
  "Phoenix",
  "Quartz",
  "Rune",
  "Shield",
  "Temple",
  "Umbral",
  "Vale",
  "Warden",
  "Axiom",
  "Barrow",
  "Crag",
  "Drake",
  "Elder",
  "Forge",
  "Golem",
  "Hearth",
  "Idol",
  "Javelin",
  "Kraken",
  "Lance",
  "Manor",
  "Nether",
  "Obelisk",
  "Pillar",
  "Quill",
  "Ridge",
  "Scepter",
  "Tome",
  "Urn",
  "Vault",
  "Wisp",
  "Yew",
  "Zephyr",
  "Arena",
  "Bastion",
  "Cinder",
  "Dawn",
  "Echo",
  "Frost",
  "Gale",
  "Isle",
  "Keep",
  "Loom",
  "Moss",
  "Nova",
  "Pike",
  "Reef",
  "Spire",
  "Torch",
  "Vow",
  "Wraith",
];

function pickWord(pool, used, random) {
  const available = pool.filter((word) => !used.has(word));
  const source = available.length ? available : pool;
  return source[Math.floor(random() * source.length)];
}

function shuffle(items, random) {
  const result = items.slice();
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    const temp = result[index];
    result[index] = result[swapIndex];
    result[swapIndex] = temp;
  }
  return result;
}

export function generateGuestUsername(random = Math.random) {
  const wordCount = 4;
  const used = new Set();
  const parts = [];
  for (let index = 0; index < wordCount; index += 1) {
    const pool = random() < 0.45 ? VERBS : NOUNS;
    const word = pickWord(pool, used, random);
    used.add(word);
    parts.push(word);
  }
  return shuffle(parts, random).join("").slice(0, 40);
}

export { VERBS, NOUNS };
